export default __webpack_public_path__ + "static/loading_mrt-6df7f4ec14026e7e44c6953e8a203f8c.gif";